<template>
<div class="add-label"  v-loading="loading">
    <div class="add-label-title">新增标签</div>
    <!--标签类型-->
    <el-tabs v-model="form.labelType" @tab-click="handleClick">
        <el-tab-pane label="静态标签" name="0">
            <!--静态-->
            <el-form v-if="form.labelType== '0'" label-width="120px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                <el-form-item  label="标签名称：" prop="labelName">
                    <el-input placeholder="请输入标签名称" v-model="form.labelName"></el-input>
                </el-form-item>
                <el-form-item  label="管辖部门：" ref="deptListv" prop="deptList" >
                    <TreeSelect size="small" :data="departmentData"
                                clearable
                                multiple
                                expandAll
                                ref="deptDouble"
                                :obj="mapKey"
                                checkStrictly
                                @getValue="setDeptDoubleMenu">
                    </TreeSelect>
                </el-form-item>
                <el-form-item  label="可管理岗位：" ref="postListv" prop="postList">
                    <el-input
                            placeholder="请选择成员"
                            style="width: 305px"
                            v-model="userText"
                            @focus=" isShowCheck= true"
                    ></el-input>
                    <CheckBox :data="jobList"
                              :title="'岗位选择'"
                              :isShowCheck="isShowCheck"
                              @setShow="setCkeckShow"
                              @getValue="setCheckValue"></CheckBox>
                </el-form-item>
                <el-form-item  class="tx-c">
                    <el-button @click="submitForm0('ruleForm')" type="primary">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="动态标签" name="1">
            <!--动态-->
            <el-form v-if="form.labelType== '1'" label-width="120px"  class="demo-form-inline">
                <el-form-item  label="标签名称：" >
                    <el-input placeholder="请输入标签名称" v-model="form2.labelName" @blur="nameChange"></el-input>
                </el-form-item>
                <div v-if="tagsRulesShowL" class="tagsRulesShow">请输入标签名称</div>
                <el-form-item label="条件：" >
                <Tags @setTagsData="setTagsData"></Tags>
                </el-form-item>
                <div v-if="tagsRulesShow" class="tagsRulesShow">请新增动态标签</div>
                <el-form-item class="tx-c">
                <el-button @click="submitForm1()" type="primary">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
    </el-tabs>
    <!--<charge-person-->
            <!--ref="personModal"-->
            <!--:personData="personData"-->
            <!--@closePerson="closePerson"-->
    <!--/>-->
</div>
</template>

<script>
    import Tags from '@/components/management/label/tags.vue'
    import CheckBox from "@/components/CheckBox.vue";
    import TreeSelect from "@/components/TreeSelect.vue";
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    import {getAllJobList} from '@/api/managementCenter/jobManage';
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";
    import { handleSaveOrUpdate } from '@/api/managementCenter/labelManage';
    export default {
        name: "addLabel",
        data(){
            return {
                loading:false,
                postList:[],
                userText:'',
                userId:[],
                deptList:[],
                isShowCheck:false,
                form: {
                    labelId: '',
                    labelName:"", //标签名称
                    labelType: "0", //标签类型
                    labelDept: '',//所管辖部门
                    deptList:[],//管辖部门
                    postList:[],//可管理岗位
                    userList:[], //管理用户
                    deptName: '' //部门中文名，便于详情回显
                },
                form2: {
                    labelName:"", //标签名称
                },
                rules: {
                    labelName: [
                        { required: true, message: "请输入标签名称", trigger: "blur" }
                    ],
                    deptList: [
                        { required: true, message: "请选择部门", trigger: "change" }
                    ],
                    postList: [
                        { required: true, message: "请选择可管理岗位", trigger: "blur" }
                    ],
                },
                rules2: {
                    labelName: [
                        { required: true, message: "请输入标签名称", trigger: "blur" }
                    ],
                    cond: [
                        { required: true, message: "请选择新增标签", trigger: "change" }
                    ]
                },
                tagsRulesShow: false,
                tagsRulesShowL: false,
                jobList:[],
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: []
                },
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                departmentData:[],
                tagsData: [] //新增动态标签数据
            }
        },
        components:{
            TreeSelect,
            CheckBox,
            Tags,
            chargePerson
        },
        mounted(){
            this.getJobListFn();
            this.getDeptTreeData();
        },
        methods:{
            //动态静态切换
            handleClick(){
                // if(this.form.labelType== '1'){
                //     this.$refs['ruleForm'].resetFields()
                // }
                this.tagsRulesShow = false
                this.form.labelName = ''
                this.form2.labelName = ''
                this.userText = ''
            },
            // 获取新增动态标签数据
            setTagsData(val){
                if(val.length == 0){
                    this.tagsRulesShow =true
                }else {
                    this.tagsRulesShow =false
                }
                this.tagsData = val
            },
            //获取岗位数据
            getJobListFn(){
                getAllJobList().then(({data}) => {
                    if(data.code == 0){
                        this.jobList=data.data.map((item) =>{
                            return {
                                id: item.postId,
                                name: item.postName
                            }
                        }) || []
                    }else{
                        this.$message.warning( data.msg||"获取岗位失败！" );
                    }
                }).catch(err=>{
                })
            },
            //获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }

                    }
                }).catch(err=>{

                })

            },
            setDeptDoubleMenu(key,data){//获取子组件值
                // this.doubleSelect = data.map(item=>item.id)
                if(key.length == 0){
                    this.$refs['ruleForm'].validateField('deptList');
                    this.form.deptList = []
                    this.form.deptName = []
                }else {
                    this.$refs['deptListv'].resetField()
                    this.form.deptList = key.map((item) =>{
                        return {
                            labelId: '',
                            deptId: item.toString()
                        }
                    })
                    this.form.deptName = data.map((item) =>{
                        return item.name
                    })
                }
            },
            //获取复选框数据
            setCheckValue(ids,value){
               if(ids.length == 0){
                   this.$refs['ruleForm'].validateField('postList');
                   this.postList = []
                   this.userText = ''
               }else {
                   this.$refs['postListv'].resetField()
                   this.postList = ids
                   this.userText = value.toString()
               }
            },
            setCkeckShow(value){
              this.isShowCheck = value
            },
            saveOrUpdate(){
                this.loading = true;
                let params = {
                    deptList: this.form.deptList,
                    labelName: this.form.labelName,
                    labelType: this.form.labelType,
                    postList: this.form.postList
                }
                handleSaveOrUpdate(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "保存成功!" );
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  data.msg||"保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 静态标签提交
            submitForm0 (formName) {
                if(this.form.deptList.length == 0) {
                    this.$refs['deptListv'].resetField()
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveOrUpdate()
                    } else {
                        return false;
                    }
                });
            },
            nameChange(){
                if(this.form2.labelName == ''){
                    this.tagsRulesShowL =true
                }else {
                    this.tagsRulesShowL =false
                }
            },
            //动态标签提交
            submitForm1(){
                if(this.form2.labelName == '' ){
                    this.tagsRulesShowL =true
                }
                if(this.tagsData.length == 0) {
                    this.tagsRulesShow =true
                    return
                }else {
                    this.tagsRulesShow =false
                }
                if(this.form2.labelName != '' && this.tagsData.length > 0){
                    let params = {
                        labelType: this.form.labelType,
                        labelName: this.form2.labelName,
                        labelConditions: JSON.stringify({conditions:this.tagsData})
                    }
                        handleSaveOrUpdate(params).then(({data})=>{
                            this.loading = false;
                            if(data.code == 0) {
                                this.$message.success(  "保存成功!" );
                                this.$emit('saveSuccess')

                            }else{
                                this.$message.warning(  data.msg||"保存失败!" );
                            }
                        }).catch(err=>{
                            this.loading = false;
                            this.$message.error(  "服务器异常!" );
                        })
                }
            },
            //显示人员选择
            addUser() {
                this.personData.state = true;
            },
            //选择人员
            closePerson(value) {
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                this.userText= (mans.map(item=>item.name)).join("、");
                this.userId= mans.map(item=>item.userId);
                this.personData.state = false;
            },
        },
        watch: {
            postList(val){
                this.form.postList=(val||[]).map(i=>{
                    return {postId:i};
                })
            },
            userId(val){
                this.form.userList=(val||[]).map(i=>{
                    return {userId:i};
                })
            }
        },

    }
</script>

<style scoped lang="less">
.add-label{
    padding: 60px 20px 0 20px;
    &-title{
        font-weight: bold;
        text-align: center;
        padding: 30px 0;
        font-size: 18px;
    }
    .tagsRulesShow{
        padding: 3px 0;
        font-size: 12px;
        color: #F56C6C;
        padding-left: 120px;
    }
}
</style>
